<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <div class="search-form width-100">
            <!--<span class="search hidden&#45;&#45;xs">-->
            <!--<span class="search__icon">-->
            <!--<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">-->
            <!--<path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>-->
            <!--</svg>-->
            <!--</span>-->
            <!--<span class="search__input">-->
            <!--<input type="text" class="form__input" placeholder="Search transfers">-->
            <!--</span>-->
            <!--</span>-->
            <div class="panel__header__left"><b>{{ name }}</b> &nbsp; Balance History</div>
          </div>
        </div>
        <div class="panel__header__right">
          <div class="filter__options">
            <button
              class="btn btn--default btn--flex"
              data-toggle="modal"
              data-target="#createFilteredModal"
            >
              <span class="btn__icon">
                <svg
                  class
                  enable-background="new 0 0 971.986 971.986"
                  version="1.1"
                  viewBox="0 0 971.986 971.986"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#576ae6"
                    d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z"
                  ></path>
                </svg>
              </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>
          <!--<div class="select filter__date">-->
          <!--<select name="disburse-source" id="disburseSource" class="select__input select__input&#45;&#45;sm">-->
          <!--<option value="Bank source">Today</option>-->
          <!--<option value="Card source">Yesterday</option>-->
          <!--</select>-->
          <!--<div class="select__icon">-->
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>-->
          <!--</div>-->
          <!--</div>-->
          <div class="filter__options" style="padding-left: 15px;">
            <button class="btn btn--default" @click="handleWalletFundingHistory(1)" id="DownloadFile">
              Download
            </button>
          </div>
          <div class="contact-trigger">
            <router-link
              :to="{name:'single-disburse-id'}"
              class="btn btn--primary btn--flex"
            >+ New Transfer</router-link>
          </div>
        </div>
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <div class="table__section table__section--head" data-toggle="modal"
          data-target="#createFilteredModal">
          Showing
          <span class="pointer">{{message}}</span>
        </div>
        <div class="loaderContainer" v-if="isLoading">
          <img src="/static/wave.gif" alt width="32" height="32">
        </div>

        <transition name="slide-fade">
          <div class="table" v-if="!walletHistoryEmpty">
            <!-- Table body -->
            <div
              class="table__section table__section--body"
              v-for="transaction in walletHistory.data"
            >
              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">
                    {{ momentDate(transaction.createdAt) }}
                    <br>
                    {{ momentTime(transaction.createdAt )}}
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <!--<div class="table__data--default" v-if="transaction.id === null">Unavailable</div>-->
                  <!--<div class="table__data--default" v-else>{{transaction.id}}</div>-->
                  <div class="table__data--default" v-if="transaction.flutterReference !== null">
                    <span>{{transaction.flutterReference}}</span>
                  </div>
                  <div class="table__data--default">{{transaction.ref}}</div>
                </div>
                <!-- table data -->
                <div class="table__data" v-if="Number(transaction.amount) < 0">
                  <div
                    class="table__data--bold"
                  >{{transaction.shortCode}} {{Number(transaction.amount).toLocaleString()}}</div>
                  <div
                    class="table__data--sub"
                  >Fee: {{transaction.fee}} | Amount: {{Math.abs(Number(transaction.amount)) - Number(transaction.fee).toLocaleString()}}</div>
                </div>

                <div class="table__data" v-else-if="Number(transaction.amount) > 0">
                  <div
                    class="table__data--bold"
                  >{{transaction.shortCode}} {{Number(transaction.amount).toLocaleString()}}</div>
                  <div
                    class="table__data--sub"
                  >Fee: {{transaction.fee}} | Amount: {{(Math.abs(Number(transaction.amount)) - Number(transaction.fee)).toLocaleString()}}</div>
                </div>

                <!-- table data -->
                <div class="table__data" v-if="Number(transaction.amount) < 0">
                  <div class="tag" :class="['tag--failed']">DEBIT</div>
                </div>

                <div class="table__data" v-else-if="Number(transaction.amount) > 0">
                  <div class="tag" :class="['tag--completed']">CREDIT</div>
                </div>

                <!--table data-->
                <div class="table__data">
                  <div
                    class="table__data--bold"
                  >{{transaction.shortCode}} {{Number(transaction.balance).toLocaleString()}}</div>
                  <div class="table__data--sub">Balance</div>
                </div>
              </div>
              <div class="table__row spacer"></div>
            </div>
          </div>
          <div class="panel__empty" v-if="walletHistoryEmpty">
            <div class="panel__empty__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70">
                <g fill="none" fill-rule="evenodd" transform="translate(-1 -1)">
                  <rect
                    width="43"
                    height="60"
                    x="10"
                    y="6"
                    fill="#D6DBEB"
                    opacity=".269"
                    rx="3"
                    transform="rotate(-22 31.5 36)"
                  ></rect>
                  <rect
                    width="43"
                    height="60"
                    x="41"
                    y="6"
                    fill="#D6DBEB"
                    opacity=".269"
                    rx="3"
                    transform="rotate(22 62.5 36)"
                  ></rect>
                  <g fill-rule="nonzero">
                    <g transform="translate(47 45)">
                      <path
                        fill="#4B536B"
                        d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"
                      ></path>
                      <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                      <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                    </g>
                    <path
                      fill="#4B536B"
                      d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"
                    ></path>
                    <g fill="#4B536B">
                      <path
                        d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"
                      ></path>
                      <g>
                        <path
                          d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"
                        ></path>
                        <path
                          d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="panel__empty__text">
              Balance History list empty.
              <router-link :to="{name:'single-disburse'}" class="link">Send money</router-link>to a beneficiary
              Or change your
              <span
                class="link pointer"
                data-toggle="modal"
                data-target="#createFilteredModal"
              >filter</span>
            </div>
          </div>
        </transition>

        <div class="table table--special-width">
          <!-- Table body -->
          <div class="table__section table__section--body">
            <!-- table row -->
          </div>
        </div>
      </div>
    </div>
    <!--pagination-->
    <transition name="slide-fade">
      <pagination
        :paginationProp="paginationProp"
        v-if="!paginationProp.paginationEmpty"
        :key="paginationProp.pagination.total"
      ></pagination>
    </transition>
    <div
      class="modal fade"
      id="createFilteredModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createFilteredModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xsf" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <!-- Modal Body -->
          <div class="modal__body">
            <div class>
              <form action class="form form__padf" @submit.prevent="handleWalletFundingHistory()">
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    :placeholder="'Date Start'"
                    @selected="formatStartDate"
                    :value="search.createdAt.from"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    :placeholder="'Date End'"
                    @selected="formatEndDate"
                    :value="search.createdAt.to"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <input
                    type="text"
                    name="reference"
                    placeholder="Reference"
                    v-model="search.flutterReference"
                    id="walletName"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
                <div class="form__item">
                  <select
                    name="status"
                    class="select__input select__input--md"
                    v-model="search.status"
                  >
                    <option value>Select a Status</option>
                    <option value="completed">Completed</option>
                    <option value="Failed">Failed</option>
                    <option value="pending">pending</option>
                  </select>
                  <div class="select__icon select__icon--in-pagination">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                    >
                      <path
                        fill="#42476f"
                        fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                      ></path>
                    </svg>
                  </div>
                </div>

                <br>
                <br>

                <div class="form__item">
                  <button
                    id="fundWallet"
                    type="submit"
                    class="btn btn--primary btn--block beneficiary_submit"
                    @click="filter()"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createFilteredModal"
                  >Create Filter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationView from "@/components/partials/PaginationView";
import { getWalletFundingHistory } from "../../utils/wallet-transactions/walletService";
import ta from "time-ago";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  created() {
    this.handleWalletFundingHistory(); // Fetches posts when the component is created.
  },

  mounted() {},

  beforeRouteUpdate(to, from, next) {
    this.$Progress.start();
    this.handleWalletFundingHistory();
    this.$Progress.finish();
    // don't forget to call next()
    next();
  },

  data() {
    return {
      name: "",
      search: {
        createdAt: {
          from: "",
          to: ""
        },
        flutterReference: "",
        status: ""
      },
      message: "",
      paginationProp: {
        pagination: {},
        paginationEmpty: true,
        pathName: ""
      },
      isLoading: true,
      showModal: false,
      selected: "All",
      download: 0,
      options: {},
      singleFullErrors: [],
      count: "",
      itemPerPage: "",
      walletHistory: [],
      walletHistoryEmpty: false
    };
  },

  components: {
    pagination: PaginationView,
    Datepicker
  },
  // funding --- type and dest(wallet);
  // disburment -- type and source(wallet)
  watch: {
    // call again the fetch method if the route changes
    $route: "getWalletFundingHistory"
  },

  methods: {

    momentDate(date) {
        return moment(date).format('YYYY-MM-DD')
    },
    momentTime(time){
        return moment(date).format('HH:mma')
    },
    createdAgo(time) {
      return ta.ago(time);
    },
    formatDateRange(start, end) {
      const startD = moment(start).format("D");
      const endD = moment(end).format("D");
      const startMn = moment(start).format("MM");
      const endMn = moment(end).format("MM");
      const startYr = moment(start).format("YY");
      const endYr = moment(end).format("YY");
      let d = "";

      if (startD === endD && startMn === endMn && startYr === endYr) {
        d = `${startD} ${moment(end).format("MMMM")} ${endYr}`;
      } else if (startMn === endMn && startYr === endYr) {
        d = `${startD} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMMM"
        )} ${endYr}`;
      } else if (startYr === endYr) {
        d = `${startD} ${moment(start).format("MMM")} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      } else {
        d = `${startD} ${moment(start).format("MMM")} ${startYr} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      }

      return d;
    },
    formatStartDate (date) {
      this.search.createdAt.from = moment(date).format().toString().split('T')[0];
    },

    formatEndDate (date) {
      this.search.createdAt.to = moment(date).format().toString().split('T')[0];
    },
    filter() {
      // window.localStorage.setItem('date', this.date);
      let data = {};
      if (this.search.createdAt.from == null) {
        this.search.createdAt.from = "";
      }
      if (this.search.createdAt.to == null) {
        this.search.createdAt.to = "";
      }
      data = this.search;
      this.$store.commit("updateSingleBalanceFullSearch", data);
      // location.reload();
    },
    downloadFile(text){
      window.open(text, "_blank");
    },
    handleWalletFundingHistory(download = 0) {
      this.download = download;
      let data2 = {};
      if (window.localStorage.getItem("SingleWalletHistorySearch") == null) {
        this.search.createdAt.from = moment()
          .startOf("month")
          .format().toString().split('T')[0];
        this.search.createdAt.to = moment().format().toString().split('T')[0];
        data2 = this.search;
        this.$store.commit("updateSingleBalanceFullSearch", data2);
      }
      data2 = JSON.parse(
        window.localStorage.getItem("SingleWalletHistorySearch")
      );
      this.search = JSON.parse(
        window.localStorage.getItem("SingleWalletHistorySearch")
      );
      this.message = "this wallet history ";
      this.$Progress.start();
      let walletarray = window.localStorage.getItem('walletList');
      Object.keys(JSON.parse(walletarray)).forEach((rep) => {
        if(JSON.parse(walletarray)[rep].currencyId === this.$route.params.id) this.name = JSON.parse(walletarray)[rep].name.toUpperCase();
      });
      getWalletFundingHistory(
        this.$route.params.id,
        this.$route.query.per_page,
        this.$route.query.page,
        data2,
        this.download,
      )
      .then(response => {
        if(response.status === 200) {
          if(response.data.data){
            this.isLoading = false;
            this.walletHistoryEmpty = false;
            this.$Progress.finish();
            if (this.search["flutterReference"] !== "") {
              this.message += "• " + this.search["flutterReference"] + " ";
            }
            if (this.search.status !== "") {
              this.message += "• " + this.search.status.toUpperCase() + " ";
            }
            let date = this.formatDateRange(
              this.search["createdAt"]["from"],
              this.search["createdAt"]["to"]
            );
            this.message += "• " + date;

            if (
              Object.keys(response.data.data).length === 0 &&
              typeof response.data.data === "object"
            ) {
              this.walletHistoryEmpty = true;
            } else {
              this.walletHistory = response.data;
            }
            if (response.data.meta.pagination.total > 0) {
              this.paginationProp.pagination = response.data.meta.pagination;
              this.paginationProp.paginationEmpty = false;
              this.paginationProp.pathName = this.$route.name;
            } else {
              this.paginationProp.paginationEmpty = true;
            }
          }
          else if(response.data.file){
            this.$Progress.finish();
            this.downloadFile(`https://frontend.moneywaveapp.com/admin/v1/file/${response.data.file.split('file/')[1]}`);
          }
        }
      })
      .catch(e => {
        console.log(e);
        this.singleFullErrors.push(e);
      });
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(parseInt(this.count) / parseInt(this.itemPerPage));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wallet/SingleBalanceFull.vue